import React from "react";

const About = () => {
  return (
    <div name="About" className="about">
      <div className="about_content">
        <h2>About Me</h2>
        <p>
          Hi 👋 My name is Aleksandar Conić, and I am a Fullstack Developer from
          Serbia. I enjoy combining different technologies to create interesting
          projects, and I have over three years of experience developing web
          apps. Creating animations for my web pages is one of the most exciting
          components of my job. If you'd like to contact me, you can reach me
          via email at <span>acaconic99@gmail.com</span>
        </p>
      </div>
    </div>
  );
};

export default About;
